import React from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import { Link } from 'react-router-dom';

import CheckBox from '../../../../components/checkBox';


const RightSide = ({
  t,
  color,
  isLoad,
  active,
  hasMore,
  checked,
  showMenu,
  lastPosts,
  chooseCat,
  categories,
  toggleMenu,
  updateChecked,
  loadMoreCategories,
}) => (
  <div className="rightw">
    <a
      href="#"
      className="show-more"
      onClick={e => toggleMenu(e)}
    >
      <img
        src="/img/droparrow.svg"
        height="8px"
        className={`img-margin ${showMenu ? 'img-rotate' : ''}`}
      />
      {showMenu ? t('Show less') : t('Show more')}
    </a>
    <div className={`rightinner boxs right${showMenu ? '_act' : '_dis'}`}>
      <div className="newsouter boxs">
        <ul
          className="newsul fontmulisemi boxs mgtbloglink forscroll2 blog-cat-list"
        >
          {!isLoad &&
          <React.Fragment>
            <li key={-1} className={color || ''}>
              <a
                href="#"
                className={`tc ${checked[-1] ? 'tc_act' : 'tc_dis'}`}
                onClick={e => chooseCat(e, { id: -1 })}
              >
                <CheckBox
                  index={-1}
                  updateChecked={updateChecked}
                  checked={checked[-1]}
                />
                {t('Uncategorized')}
              </a>
            </li>
            <InfiniteScroll
              loadMore={loadMoreCategories}
              hasMore={hasMore}
              pageStart={0}
              useWindow={false}
              loader={<div className="loader" key={0}>{t('Loading')} ...</div>}
            >
              {categories.map(cat => (
                <li key={cat.id} className={color || ''}>
                  <a
                    href="#"
                    className={`tc ${checked[cat.id] ? 'tc_act' : 'tc_dis'}`}
                    onClick={e => chooseCat(e, cat)}
                  >
                    <CheckBox
                      index={cat.id}
                      updateChecked={updateChecked}
                      checked={checked[cat.id]}
                    />
                    {cat.title}
                  </a>
                </li>
                      ))}
            </InfiniteScroll>
          </React.Fragment>}
        </ul>
      </div>
      <div className="blog2tabsouter boxs">
        {lastPosts.length ?
          <ul className="blog2tabs fontmulisemi blog-recent-list">
            {lastPosts.map(post =>
              (<li key={post.id} className={color || ''}>
                <Link
                  to={`/blog/post-${post.id}`}
                  className={`tc ${post.id === active ? 'tc_act' : 'tc_dis'}`}
                >
                  {post.title}
                </Link>
               </li>))}
          </ul> :
                    '' }
      </div>
    </div>
  </div>

);

RightSide.propTypes = {
  isLoad: PropTypes.bool.isRequired,
  hasMore: PropTypes.bool.isRequired,
  checked: PropTypes.object.isRequired,
  lastPosts: PropTypes.array.isRequired,
  chooseCat: PropTypes.func.isRequired,
  categories: PropTypes.array.isRequired,
  updateChecked: PropTypes.func.isRequired,
  loadMoreCategories: PropTypes.func.isRequired,
};

export default RightSide;



// WEBPACK FOOTER //
// ./src/views/modules/blog/rightSide/RightSide.js